import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex, rem, SparklesOutline, Text } from '@bonusly/design-system';

import { useBookmark } from '../../context';
import { useGenerateAiSuggestedLabels } from './hooks';
import { SuggestionPill } from './suggestion-pill';

export const SuggestionsDisplay: FC = () => {
	const { t } = useTranslation('bookmarks');

	const { bookmark } = useBookmark();
	const { data: suggestedLabels } = useGenerateAiSuggestedLabels();

	if (!suggestedLabels || (bookmark?.labels ?? []).length > 0) {
		return null;
	}

	return (
		<Flex w="full" p={3} bg="primary.bgAlpha" borderRadius="md" gap={2}>
			<Box>
				<SparklesOutline color="primary.fgStrong" w={5} h={5} />
			</Box>
			<Flex direction="column" w="full" gap={rem(10)}>
				<Text size="sm" fontWeight={500}>
					{t('suggestions.content')}
				</Text>
				<Flex columnGap={2} rowGap={2} flexWrap="wrap">
					{suggestedLabels?.map((suggestion) => <SuggestionPill key={suggestion.name} suggestion={suggestion} />)}
				</Flex>
			</Flex>
		</Flex>
	);
};
